/*eslint-disable*/
import React, { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  TextField,
  Paper,
  Divider,
  FormControl,
  InputLabel,
  Select,
  Box
} from "@mui/material";
import { STYLES } from "config";
import CustomDropDownPicker from "../../../components/CustomDropDownPicker";

function SecurityInformation(props) {
  const { data, setvalue } = props;
  const [state, setstate] = useState(data);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    setstate(data);
  }, [data]);

  const validateField = (name, value) => {
    let error = "";

    if (name === "security" && !value) {
      error = "Security selection is required";
    } else if (name === "securityDesc" && !value && state.security === "yes") {
      error = "Security description is required when security is enabled";
    }

    setErrors((prev) => ({ ...prev, [name]: error }));
    return !error;
  };

  const updateData = (e) => {
    const { name, value } = e.target;
    const isValid = validateField(name, value);

    if (isValid) {
      const updatedState = { ...state, [name]: value };
      setstate(updatedState);
      setvalue(updatedState);
    }
  };
  const handleDropdownChange = (name, value) => {
    const updatedState = { ...state, [name]: value };
    setstate(updatedState);
    setvalue(updatedState);
  };
  const inputStyle = {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#003366"
      },
      "&:hover fieldset": {
        borderColor: "#003366"
      }
    }
  };

  return (
    <Paper elevation={5} sx={{ p: 3, maxHeight: "800vh", overflowY: "auto" }}>
      <Box sx={{ p: 2 }}>
        <Typography
          variant="h5"
          gutterBottom
          sx={{ color: STYLES.WEB_APP_FONT_CLR }}
        >
          Security
        </Typography>
        <Divider sx={{ bgcolor: STYLES.WEB_APP_FONT_CLR, mb: 2 }} />

        <Typography
          variant="body1"
          paragraph
          sx={{ color: STYLES.WEB_APP_FONT_CLR }}
        >
          Capture any security features for the property here.
        </Typography>

        <Divider sx={{ bgcolor: STYLES.WEB_APP_FONT_CLR, mb: 2 }} />

        <Grid container spacing={2}>
          {/* Security Dropdown */}
          <Grid item size={2}>
            <Typography
              variant="body1"
              sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}
            >
              Security <span style={{ color: "red" }}>*</span>
            </Typography>
          </Grid>
          <Grid item size={10}>
            <FormControl fullWidth sx={inputStyle}>
              <CustomDropDownPicker
                name="security"
                value={state?.security || "no"}
                onChange={(value) => handleDropdownChange("security", value)}
                options={[
                  { value: "yes", label: "Yes" },
                  { value: "no", label: "No" }
                ]}
                error={!!errors.security}
                helperText={errors.security}
              />
            </FormControl>
          </Grid>

          {/* Security Description */}
          <Grid item size={2}>
            <Typography
              variant="body1"
              sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}
            >
              Description {state?.security === "yes" && "*"}
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              size="small"
              multiline
              rows={4}
              name="securityDesc"
              value={state?.securityDesc || ""}
              onChange={updateData}
              error={!!errors.securityDesc}
              helperText={errors.securityDesc}
              sx={inputStyle}
              disabled={state?.security !== "yes"}
            />
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
}

export default SecurityInformation;
